import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";
import type { z } from "zod";

import { timeFrames } from "../constants/time-frame-constants.ts";
import { UserFilterMultiselect } from "./user-filter-multiselect.tsx";

type UserFilter = {
	id: number;
	name: string;
	endpoint: string;
	schema: z.ZodSchema<unknown> | null;
	paramType: string;
};

export const QuoteBoardGlobalFilters = ({
	onHandleChange,
	onHandleSelectFilter,
	selectedFilter,
	selectedValue,
	onSetTimeFrame,
	userFilters,
}: {
	onSetTimeFrame: ({ value }: { value: number }) => void;
	onHandleChange: (e: {
		value: { id: string | number; name: string }[];
	}) => void;
	onHandleSelectFilter: ({ value }: { value: UserFilter }) => void;
	selectedFilter: UserFilter | undefined;
	selectedValue: { id: string | number; name: string }[];
	userFilters: UserFilter[];
	quoteType: string;
	onQuoteTypeChange: (value: string) => void;
}) => {
	return (
		<div className={"quote-board-user-filter-group"}>
			<div className={"quote-board-user-filter-group-value"}>
				<div>Time Frame</div>
				<div data-testid={"quote-board-time-frame"}>
					<DropDownList
						className={"time-frame-dropdown"}
						data={timeFrames}
						dataItemKey={"value"}
						defaultValue={timeFrames[0]}
						onChange={(e: { value: { name: string; value: number } }) =>
							onSetTimeFrame(e.value)
						}
						textField={"name"}
					/>
				</div>
			</div>

			<UserFilterMultiselect
				onHandleChange={onHandleChange}
				onHandleSelectFilter={onHandleSelectFilter}
				selectedFilter={selectedFilter}
				selectedValue={selectedValue}
				userFilters={userFilters}
			/>
		</div>
	);
};
